import { render, staticRenderFns } from "./accessConfig.vue?vue&type=template&id=61e5eb84&scoped=true"
import script from "./accessConfig.vue?vue&type=script&lang=js"
export * from "./accessConfig.vue?vue&type=script&lang=js"
import style0 from "./accessConfig.vue?vue&type=style&index=0&id=61e5eb84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e5eb84",
  null
  
)

export default component.exports